<template>
  <load-form-handler
    :promise="getTabPromise"
    v-model="resource"
    placeholder
    error="handleErrorMessage">

    <h1 class="text-center">Acompanhe a rotina escolar do seu filho.</h1>
    <v-divider class="divider-accent my-4"/>

    <v-card class="mb-4">
      <v-flex pa-4>

        <h2>Sala curricular</h2>
        <h3 class="text-secondary mb-2">Classroom</h3>

        <v-layout row wrap>
          <v-flex xs12 sm6 lg4>
            <h3>Prédio</h3>
            <h4 class="text-secondary">Building</h4>
            <p>{{ buildingName }}</p>
          </v-flex>
          <v-flex xs12 sm6 lg4>
            <h3>Sala</h3>
            <h4 class="text-secondary">Classroom</h4>
            <p>{{ classroomName }}</p>
          </v-flex>
          <v-flex xs12>
            <h3>Extra</h3>
            <p>{{ resource.extra || 'Sem informações. / No informations.' }}</p>
          </v-flex>
        </v-layout>

        <v-divider class="my-4 divider-primary"/>

        <h2>Agenda de atividades</h2>
        <h3 class="text-secondary mb-2">Activity schedule</h3>
        <form-student-activities />

        <v-divider class="my-4 divider-primary"/>

        <h2>Refeições</h2>
        <h3 class="text-secondary mb-2">Meals</h3>
        <form-student-meal />

        <v-divider class="my-4 divider-primary"/>

        <h2>Agenda de aulas para solicitação de saída</h2>
        <h3 class="text-secondary mb-2">Class schedule for exit request </h3>
        <form-student-classroom />

      </v-flex>
    </v-card>
  </load-form-handler>
</template>

<script>
import LoadFormHandler from '@/components/LoadFormHandler'
import { message, formTabs } from '@/mixins'
import * as api from '@/api'

import FormStudentActivities from './FormStudentActivities'
import FormStudentMeal from './FormStudentMeal'
import FormStudentClassroom from './FormStudentClassroom'

export default {
  name: 'FormStudentSchoolRoutine',

  components: {
    LoadFormHandler,
    FormStudentActivities,
    FormStudentMeal,
    FormStudentClassroom
  },

  data: () => ({
    resource: {},
    buildings: [],
    classrooms: []
  }),

  mixins: [formTabs, message],

  provide () {
    const resource = {}
    Object.defineProperty(resource, 'form', {
      enumerable: true,
      get: () => this.resource
    })
    return { resource }
  },

  computed: {
    buildingName () {
      return (this.buildings.find(building => building.id === this.resource.building_id) || {}).name ||
        this.resource.building_id ||
        'Prédio não registrado. / Unregistered building.'
    },

    classroomName () {
      return (this.classrooms.find(classroom => classroom.id === this.resource.classroom_id) || {}).name ||
        this.resource.classroom_id ||
        'Sala não registrada. / Unregistered Room.'
    }
  },

  mounted () {
    this.getBuildings()
  },

  watch: {
    resource (newValue) {
      if (newValue.building_id) {
        this.getClassrooms()
      }
    }
  },

  methods: {
    getTabPromise () {
      return api.forms.schoolRoutine.get(this.currentStudentId)
    },

    getBuildings () {
      api.forms.information.getBuildings()
        .then(({ data }) => {
          this.buildings = data
        })
    },

    getClassrooms () {
      api.forms.information.getClassrooms(this.resource.building_id)
        .then(({ data }) => {
          this.classrooms = data
        })
    }
  }
}
</script>
